"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonAccordion = require("@mmc/common-accordion");
var _commonCta = require("@mmc/common-cta");
var _commonRichText = require("@mmc/common-rich-text");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactRedux = require("react-redux");
var _commonI18n = require("@mmc/common-i18n");
var _text = require("@mmc/text");
var _commonErrorBoundary = require("@mmc/common-error-boundary");
var _financeSummary = _interopRequireDefault(require("./finance-summary"));
var _configuratorLargeSummary = require("./configurator-large-summary.props/configurator-large-summary.propTypes");
var _configuratorLargeSummary2 = _interopRequireDefault(require("../styles/configurator-large-summary.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  isEmptyArray = dataUtils.isEmptyArray;
var convertToCapitalizedCase = function convertToCapitalizedCase(str) {
  return str.split(' ').map(function (w) {
    return w && w[0] ? w[0].toUpperCase() + w.substr(1).toLowerCase() : '';
  }).join(' ');
};
var getPanelData = function getPanelData(params) {
  var market = params.market,
    color = params.color,
    fabric = params.fabric,
    packages = params.packages,
    accessories = params.accessories,
    includedPrice = params.includedPrice,
    changeText = params.changeText,
    changeColor = params.changeColor,
    changeFabric = params.changeFabric,
    changePackages = params.changePackages,
    changeAccessories = params.changeAccessories,
    summaryFinanceData = params.summaryFinanceData,
    additionalPriceGroup = params.additionalPriceGroup;
  var panels = [];
  var totalPrice = summaryFinanceData.totalPrice,
    labels = summaryFinanceData.labels;
  var destinationFees = additionalPriceGroup.destinationFees;
  var sumOfAdditionalPrices = additionalPriceGroup ? additionalPriceGroup.color + additionalPriceGroup.fabric + additionalPriceGroup["package"] + additionalPriceGroup.accessory + destinationFees : 0;
  if (market === 'us' && totalPrice && totalPrice !== 0 && additionalPriceGroup) {
    panels.push({
      id: 'basemsrp',
      includedText: '',
      changeText: '',
      header: {
        label: labels.baseMsrp,
        price: totalPrice - sumOfAdditionalPrices
      },
      body: {
        description: '',
        changeEvent: null
      }
    });
  }
  if (color !== undefined && color !== ' ') {
    if (color.code) {
      panels.push({
        id: 'color',
        includedPrice: includedPrice,
        changeText: changeText,
        header: {
          label: convertToCapitalizedCase(handleNestedProp(color, 'color.label')) + " ",
          price: handleNestedProp(color, 'color.price.value')
        },
        body: {
          description: handleNestedProp(color, 'color.titleAndText.text'),
          changeEvent: changeColor
        }
      });
    }
  }
  if (fabric !== undefined && fabric !== ' ') {
    if (fabric.code) {
      panels.push({
        id: 'fabric',
        includedPrice: includedPrice,
        changeText: changeText,
        header: {
          label: convertToCapitalizedCase(handleNestedProp(fabric, 'fabric.label')) + " ",
          price: handleNestedProp(fabric, 'fabric.price.value')
        },
        body: {
          description: handleNestedProp(fabric, 'fabric.titleAndText.text'),
          changeEvent: changeFabric
        }
      });
    }
  }
  if (packages !== undefined && packages !== ' ') {
    packages.forEach(function (currentPackage, i) {
      panels.push({
        id: "packages-" + i,
        includedPrice: includedPrice,
        changeText: changeText,
        header: {
          label: handleNestedProp(currentPackage, 'currentPackage.label') + " ",
          price: handleNestedProp(currentPackage, 'currentPackage.price.value')
        },
        body: {
          description: handleNestedProp(currentPackage, 'currentPackage.titleAndText.text'),
          changeEvent: changePackages
        }
      });
    });
  }
  if (accessories !== undefined && accessories !== ' ') {
    accessories.forEach(function (currentAccessory, i) {
      panels.push({
        id: "accessories-" + i,
        includedPrice: includedPrice,
        changeText: changeText,
        header: {
          label: handleNestedProp(currentAccessory, 'currentAccessory.label') + " ",
          price: handleNestedProp(currentAccessory, 'currentAccessory.price.value')
        },
        body: {
          description: handleNestedProp(currentAccessory, 'currentAccessory.titleAndText.text'),
          changeEvent: changeAccessories
        }
      });
    });
  }
  if (market === 'us' && destinationFees && destinationFees !== 0) {
    panels.push({
      id: 'fees',
      includedText: '',
      changeText: '',
      header: {
        label: labels.destinationFees,
        price: destinationFees
      },
      body: {
        description: '',
        changeEvent: null
      }
    });
  }
  return panels;
};
var AccordionWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(AccordionWrapper, _React$Component);
  AccordionWrapper.renderPrice = function renderPrice(price, text, config) {
    if (price === 0) {
      return text;
    }
    return /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: price,
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode')
      }
    });
  };
  AccordionWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var config = props.config,
      changeLink = props.changeLink,
      includedPrice = props.includedPrice,
      color = props.color,
      fabric = props.fabric,
      packages = props.packages,
      accessories = props.accessories,
      changeColor = props.changeColor,
      changeFabric = props.changeFabric,
      changePackages = props.changePackages,
      changeAccessories = props.changeAccessories,
      summaryFinanceData = props.summaryFinanceData,
      additionalPriceGroup = props.additionalPriceGroup;
    var market = config.market;
    var panelData = getPanelData({
      market: market,
      color: color,
      fabric: fabric,
      packages: packages,
      accessories: accessories,
      includedPrice: includedPrice,
      changeText: changeLink,
      changeColor: changeColor,
      changeFabric: changeFabric,
      changePackages: changePackages,
      changeAccessories: changeAccessories,
      summaryFinanceData: summaryFinanceData,
      additionalPriceGroup: additionalPriceGroup
    });
    return {
      panelData: panelData
    };
  };
  function AccordionWrapper(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var config = props.config,
      changeLink = props.changeLink,
      includedPrice = props.includedPrice,
      color = props.color,
      fabric = props.fabric,
      packages = props.packages,
      accessories = props.accessories,
      changeColor = props.changeColor,
      changeFabric = props.changeFabric,
      changePackages = props.changePackages,
      changeAccessories = props.changeAccessories,
      summaryFinanceData = props.summaryFinanceData,
      additionalPriceGroup = props.additionalPriceGroup;
    var market = config.market;
    var panelData = getPanelData({
      market: market,
      color: color,
      fabric: fabric,
      packages: packages,
      accessories: accessories,
      includedPrice: includedPrice,
      changeText: changeLink,
      changeColor: changeColor,
      changeFabric: changeFabric,
      changePackages: changePackages,
      changeAccessories: changeAccessories,
      summaryFinanceData: summaryFinanceData,
      additionalPriceGroup: additionalPriceGroup
    });
    _this.state = {
      panelData: panelData
    };
    return _this;
  }
  var _proto = AccordionWrapper.prototype;
  _proto.renderPanels = function renderPanels(panelData, config) {
    var _this2 = this;
    if (panelData === void 0) {
      panelData = [];
    }
    var panelMarkup = [];
    panelData.forEach(function (panel) {
      panelMarkup.push(_this2.renderPanelHeader(panel, config));
      panelMarkup.push(_this2.renderPanelBody(panel));
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, panelMarkup);
  };
  _proto.renderPanelHeader = function renderPanelHeader(panel, config) {
    var theme = this.props.theme;
    var id = panel.id,
      header = panel.header,
      includedPrice = panel.includedPrice;
    var summary = this.props.summary;
    var destinationFeesDisclaimerId = summary.destinationFeesDisclaimerId;
    var _this$props = this.props,
      addPriceDisclaimer = _this$props.addPriceDisclaimer,
      disclaimerData = _this$props.disclaimerData;
    return /*#__PURE__*/_react["default"].createElement("h2", {
      key: id
    }, header.label, /*#__PURE__*/_react["default"].createElement("span", {
      className: "" + theme.bodyCopy
    }, AccordionWrapper.renderPrice(header.price, includedPrice, config), config.market === 'us' && id === 'fees' && addPriceDisclaimer && destinationFeesDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "span",
      text: " #" + destinationFeesDisclaimerId + "#",
      addPriceDisclaimer: addPriceDisclaimer,
      disclaimerData: disclaimerData
    })));
  };
  _proto.renderPanelBody = function renderPanelBody(panel) {
    var theme = this.props.theme;
    var id = panel.id,
      body = panel.body,
      changeText = panel.changeText;
    return /*#__PURE__*/_react["default"].createElement("article", {
      key: id,
      className: theme.marginBottom20
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.bodyCopy
    }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      html: body.description
    })), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        priority: 'trivial',
        label: changeText
      },
      classes: [_configuratorLargeSummary2["default"].changeLink],
      theme: theme,
      clickEvent: body.changeEvent
    }));
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      customisationTitle = _this$props2.customisationTitle,
      config = _this$props2.config,
      direction = _this$props2.direction,
      currentTheme = _this$props2.theme,
      market = _this$props2.market,
      summaryFinanceData = _this$props2.summaryFinanceData,
      summary = _this$props2.summary,
      addPriceDisclaimer = _this$props2.addPriceDisclaimer,
      priceDisclaimerId = _this$props2.priceDisclaimerId,
      disclaimerData = _this$props2.disclaimerData,
      additionalPriceGroup = _this$props2.additionalPriceGroup;
    var panelData = this.state.panelData;
    var isUS = market === 'us';
    var isCA = market === 'ca';
    var theme = currentTheme || {};
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-5'] + " " + theme['col-md-4'] + " " + theme.marginBottom60,
      dir: direction
    }, customisationTitle && !isEmptyArray(panelData) && /*#__PURE__*/_react["default"].createElement("h3", {
      className: theme.labelMedium + " " + theme.marginBottom10
    }, customisationTitle), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.marginBottom30
    }, /*#__PURE__*/_react["default"].createElement(_commonAccordion.CommonAccordion, {
      multiselectable: true,
      expectedPanelHeight: "lg",
      theme: theme
    }, this.renderPanels(panelData, config))), (isUS || isCA) && /*#__PURE__*/_react["default"].createElement(_commonErrorBoundary.CommonErrorBoundary, {
      errorMsg: "PaymentCalculator has caught an error"
    }, /*#__PURE__*/_react["default"].createElement(_financeSummary["default"], {
      theme: theme,
      config: config,
      market: market,
      summaryFinanceData: summaryFinanceData,
      summary: summary,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      additionalPriceGroup: additionalPriceGroup
    })));
  };
  return AccordionWrapper;
}(_react["default"].Component);
AccordionWrapper.displayName = 'AccordionWrapper';
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(AccordionWrapper);
exports["default"] = _default;